// extracted by mini-css-extract-plugin
module.exports = {"ButtonBase":"ButtonBase_ButtonBase__yerV9","disabled":"ButtonBase_disabled___3nSD","block":"ButtonBase_block__1i4s0"};